import { Col, Input, Form, Row } from 'antd';
import React, { Fragment, useState } from 'react';
import { translate } from 'react-i18next';
import { compose } from 'redux';
import EnhancedModal from '../../../../../../components/enhanced-modal';
import ItemList from '../../../../../../components/item-list';
import Selector from '../../../../../../components/selector';
import { DataLanguageConsumer } from '../../../../../../contexts/DataLanguage';
import { GUTTER_MD, MODAL_WIDTH_LG, SPAN_ONE_QUARTER, SPAN_THREE_QUARTERS } from '../../../../../../styles/constants';
import { getArtefactTripletFromString } from '../../../../../../utils/sdmxJson';

const mapPropsToFields = ({componentValueDefinition}) => ({
  text: Form.createFormField({value: (componentValueDefinition.mappingValue.fixedValue || "").length > 0 
        ? componentValueDefinition.mappingValue.fixedValue 
        : null}),
});

const FixedComponent = ({
    t,
    form,
    appLanguage,
    componentCodelistCodesItemsPage,
    componentCodelistCodesItemsCount,
    fetchCodelistCodesItemsPage,  
    codelistCode,
    componentValueDefinition,
    onComponentValueDefinitionValueSet,
  }) => {

    const codelistTriplet = codelistCode ? getArtefactTripletFromString(codelistCode) : null;

    const [isCodeSelectorVisible, setCodeSelectorVisible] = useState(false);

    const onComponentValueSet = (value) => {
      onComponentValueDefinitionValueSet(value);
      setCodeSelectorVisible(false);
    }
  

    return (
      <Fragment>
        <Row gutter={GUTTER_MD} type="flex" align="top" >
          <Col span={SPAN_ONE_QUARTER}>
            {`${componentValueDefinition.cubeComponent.name}=`}
          </Col>
          <Col span={SPAN_THREE_QUARTERS}>
            {form.getFieldDecorator("text")(
            (codelistCode || "").length > 0 ? 
            (
              <Selector
                onSelect={() => setCodeSelectorVisible(true)}
                onReset={() => onComponentValueDefinitionValueSet(null)}
              />
            )
            : (
              
              <Input 
                title={form.getFieldValue("text")}
                onChange={({target}) =>
                    onComponentValueDefinitionValueSet(target.value)} 
              />
            )            
            )}            
          </Col>
        </Row>

        <EnhancedModal
          visible={isCodeSelectorVisible}
          onCancel={() => setCodeSelectorVisible(false)}
          title={t('scenes.dataManager.fileMapping.wizard.cards.cubeComponents.cubeComponentList.valueDefinitionForm.valueSelector.title')}
          width={MODAL_WIDTH_LG}        
          withDataLanguageSelector
        >
          <DataLanguageConsumer>   
            {dataLanguage => {
              const language = dataLanguage || appLanguage;
              return (
                <ItemList
                  data={componentCodelistCodesItemsPage || null}
                  rowCount={componentCodelistCodesItemsCount}
                  isPaginated
                  onRowClick={item => onComponentValueSet(item.id)}      
                  onChange={
                    ({pageNum, pageSize, searchText, filters, sortCol, sortByDesc}) =>
                    fetchCodelistCodesItemsPage({
                        codelistTriplet,
                        language,
                        pageNum,
                        pageSize,
                        searchText,
                        filters,
                        sortCol,
                        sortByDesc
                      })
                  }
                />
              );
            }}     
          </DataLanguageConsumer>
        </EnhancedModal>

      </Fragment>
    ); 
  };

export default compose(
  translate(),
  Form.create({mapPropsToFields})
  )(FixedComponent);  
